/**
 * Search script
 */
class ME_Search {
    constructor() {
        this.initState();
        this.initEvents();
        this.initSearchResult();
    }

    initState() {
        this.win = $(window);
        this.searchWrapper = $('.search.main');
        this.searchInput = this.searchWrapper.find('.input');
        this.searchForm = this.searchWrapper.find('form');
        this.searchResultPage = $('#search-results-list');
        this.currentHighlight = -1;
    }

    initEvents() {
        if (!this.searchInput.length) {
            return
        }

        this.searchInput.on('change, keyup', (e) => {
            let phrase = $(e.target).val();
            let keyCode = e.keyCode;
            let formUrl = this.searchForm.data('ajax-url');

            if (keyCode != 38 && keyCode != 40 && keyCode != 13) {
                this.highlightReset();

                if (phrase.length >= 3) {
                    $.ajax({
                        url: formUrl,
                        type: 'GET',
                        dataType: 'json',
                        data: {
                            searchword: phrase,
                            tmpl: 'json',
                            limit: 8
                        },
                    })
                        .done(function (response) {
                            $('.hints-list li').remove();
                            $('.hints-list').append(response.html);
                            $('.hints-list').addClass('active');
                            $('.hints-list').highlight(phrase);
                        })
                        .fail(function () {
                            console.log("error");
                        });
                } else {
                    $('.hints-list').removeClass('active');
                    $('.hints-list li').remove();
                }
            }
        });

        this.searchInput.on('click blur', () => {
            this.highlightReset();
        });

        this.searchForm.on('submit', (e) => {
            e.preventDefault();

            if ($('.hints-list .hint.active').length > 0) {
                let url = $('.hints-list .hint.active').first().find('a').attr('href');
                this.win.location.href = url;
            }
            else {
                this.searchWrapper.find('form')[0].submit();
            }
        });

        this.searchInput.on('keydown', (e) => {
            let keyCode = e.keyCode;

            if (keyCode == 40) {
                this.highlightNext();
            }

            if (keyCode == 38) {
                this.highlightPrev();
            }
        });
    }

    highlightNext() {
        this.currentHighlight += 1;
        let total = $('.hints-list .hint').length

        if (this.currentHighlight >= total) {
            this.currentHighlight = total - 1;
        }

        $('.hints-list .hint').removeClass('active');
        $('.hints-list .hint').eq(this.currentHighlight).addClass('active');
    }

    highlightPrev() {
        this.currentHighlight -= 1;

        if (this.currentHighlight <= 0) {
            this.currentHighlight = 0;
        }

        $('.hints-list .hint').removeClass('active');
        $('.hints-list .hint').eq(this.currentHighlight).addClass('active');
    }

    highlightReset() {
        this.currentHighlight = -1;
        $('.hints-list .hint').removeClass('active');
    }

    initSearchResult() {
        if (!this.searchResultPage.length) {
            return
        }

        let searchResultPagePhrase = this.searchResultPage.attr('search-phrase');
        console.log('phrase', this.searchResultPagePhrase);
        console.log('list', this.searchResultPage);
        this.searchResultPage.eq(0).highlight(searchResultPagePhrase, 'highlighted');
    }
}
